<template>
	<div class="bank">
		<div class="index-conent-left-connet1">
			<div class="list-div" v-for="(item,index) in list" :key="index">
					<router-link :to="'/question/details?id='+item.id">
				<div class="list-div-titleh2">{{item.name}}</div>
				<img :src="item.img" />
				<div class="list-div-title">
					<!-- <img src="../../assets/shudo/images/8.svg" /> -->
					<img :src="item.merchant.avatar" />
					<div>{{item.merchant.username}}</div>
					<div>{{item.count}}道题</div>
				</div>
				<div class="list-div-bao">
					{{item.brief}}
				</div>
				<div class="list-div-top">
					<div>更新：{{item.update_time|slice}}</div>
					<!-- <div></div> -->
				</div>
				</router-link>
			</div>
			
			
		</div>
	</div>
</template>

<script>
	export default {
		 
		data() {
			return {
				merchanthot_id    :  '',
				list  :  []
			}	
		},
		created() {
			var  query = this.$route.query;
			if(query.merchanthot_id){
				this.merchanthot_id = query.merchanthot_id;
				this.getlist();
			}
		},
	    methods: {
			getlist(){
				let that = this;
				that.$http('get','/api/v1/classify/all?merchant_id='+that.merchanthot_id,{}) .then(function (res) {
					that.list = res.data.list;
				});
			},
			
	    },
	}
</script>

<style lang="less">
	.bank {
		.index-conent-left-connet1{
			min-height: 14rem;
			display: flex;
			margin-top: 1rem;
			flex-wrap: wrap;
			.list-div {
				border-radius: 0.4rem;
				min-height: 9.5rem;
				background-color: #FFFFFF;
				margin-left: 1rem;
				margin-right: 1rem;
				width: 10rem;
				font-size: 0.5rem;
				img {
					display: block;
					margin: auto;
					width: 90%;
				}
				.list-div-titleh2 {
					height: 1.5rem;
					padding-left: 0.6rem;
					line-height: 1.5rem;
					font-size: 0.2rem;
					display: flex;
					div:nth-last-child(1){
						margin-left: auto;
						padding-right: 0.3rem;
						color: #878787;
					}
				}
				.list-div-title {
					padding-top: 0.3rem;
					padding-left: 0.6rem;
					display:flex;
					img {
						width: 22px;
						margin-left: 0;
					}
					div:nth-last-child(2){
						line-height: 2rem;
						flex:1;
						padding-left: 0.2rem;
						color: #181818c4;
					}
					div:nth-last-child(1){
						line-height: 2rem;
						flex:1;
						font-size: 0.5rem;
					}
				}
				.list-div-bao {
					padding-top: 0.1rem;
					padding-left: 0.6rem;
					color: #181818c4;
					font-size: 0.3rem;
				}
				.list-div-bao1{
					padding-top: 0.1rem;
					padding-left: 0.6rem;
					color: #181818c4;
					font-size: 0.3rem;
					display: flex;
					div:nth-last-child(2){
						width: 30%;
					}
					div:nth-last-child(1){
						display: flex;
						
						img{
							width: 10px;
						}
					}
				}
				.list-div-top {
					padding-top: 0.1rem;
					line-height: 1.5rem;
					display: flex;
					height: 2rem;
					div:nth-last-child(1){
						padding-left: 0.6rem;
						font-size: 0.5rem;
					
					}
				
				}
				.list-div-top1 {
					padding-top: 0.1rem;
					line-height: 1.5rem;
					display: flex;
					height: 2rem;
					div:nth-last-child(2){
						flex:1;
						display: flex;
						padding-left: 0.6rem;
						line-height: 2rem;
						img{
							width: 20px;
						}
						div {
							padding-left: 0.2rem;
						}
					}
					div:nth-last-child(1){
						flex:1;
						display: flex;
						margin-right: auto;
						line-height: 2rem;
						padding-left: 2.3rem;
						color: #d9001b;
						img{
							width: 16px;
						}
						div {
							padding-left: 0.2rem;
						}
						
					}
				}
			}
		}
	}
</style>
